import UAParser from "ua-parser-js"

export function isValidEmail(emailOrPhone: string): boolean {
  if (!emailOrPhone) { return false; }
  return validateEmail(emailOrPhone);
}

export function isValidEmailOrPhone(emailOrPhone: string): boolean {
  if (!emailOrPhone) { return false; }
  if (validateEmail(emailOrPhone)) {
    return true;
  }
  if (emailOrPhone.match(/[a-z]/i)) {
    return false;
  }
  const phone = emailOrPhone.replace(/\D/g, '');
  if (phone.length === 10) {
    return true;
  }
  return false;
}

export function isValidVerificationCode(verificationCode: string): boolean {
  if (!verificationCode) { return false; }
  return verificationCode.length === 6;
}

export function isValidRecoveryCode(recoveryCode: string): boolean {
  if (!recoveryCode) { return false; }
  return /^[0-9A-Fa-f]{5}-[0-9A-Fa-f]{5}$/.test(recoveryCode);
}

export function isValidNonce(nonce: string): boolean {
  if (!nonce) { return false; }
  return /^(\d{10}|\d{3}-\d{3}-\d{4})$/.test(nonce);
}

export function isValidGuid(guid: string): boolean {
  if (!guid) { return false; }
  const uuidRegex = /^(\{){0,1}[0-9a-f]{8}-{0,1}[0-9a-f]{4}-{0,1}[0-9a-f]{4}-{0,1}[0-9a-f]{4}-{0,1}[0-9a-f]{12}(\}){0,1}$/i;
  return uuidRegex.test(guid);
}

export function getEmail() {
  const urlParams = getQueryParams()
  return urlParams.get("email");
}

export function getIdentifier() {
  const urlParams = getQueryParams()
  return urlParams.get("participantIdentifier");
}

export function getProjectCode() {
  const urlParams = getQueryParams()
  return urlParams.get("projectCode");
}

export function getLinkKey() {
  const urlParams = getQueryParams()
  return urlParams.get("link");
}

export type UTMParameters = {
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmTerm: string | null;
  utmContent: string | null;
  [key: string]: any;
}

export function getUtmParameters(): UTMParameters {
  const urlParams = getQueryParams()
  return {
    utmSource: urlParams.get("utm_source"),
    utmMedium: urlParams.get("utm_medium"),
    utmCampaign: urlParams.get("utm_campaign"),
    utmTerm: urlParams.get("utm_term"),
    utmContent: urlParams.get("utm_content")
  }
}

export type ClickIdParameters = {
  fbclid: string | null;
  ndclid: string | null;
  gclid: string | null;
}

export function getClickIdParameters(): ClickIdParameters {
  const urlParams = getQueryParams()
  return {
    fbclid: urlParams.get("fbclid"),
    ndclid: urlParams.get("ndclid"),
    gclid: urlParams.get("gclid")
  }
}

export function validateEmail(email: string) {
  var re = /^[^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function getQueryParams() {
  return new URLSearchParams(window.location.search);
}

export function isKebabCase(str: string) {
  const pat = /(\w+)-(\w)([\w-]*)/
  return pat.test(str) && !str.includes('_')
}

export function isPascalCase(str: string) {
  const pat = /^[A-Z][A-Za-z]*$/
  return pat.test(str)
}

export function getOperatingSystem(): "iOS" | "Android" | "Other" {
    let parser = new UAParser();
    let result = parser.getResult();
    if (result.os.name == "iOS") {
      return "iOS";
    } else if (result.os.name == "Android") {
      return "Android";
    } else {
      return "Other";
    }
  }
